import { type RgbColor } from "./uploadedConversationsVisualizerParticles"

export interface UnderlayDrawInstruction {
  centerAlpha: number
  color: RgbColor
  radius: number
  x: number
  y: number
}

export function drawUnderlayInstruction(
  context: CanvasRenderingContext2D,
  instruction: UnderlayDrawInstruction,
) {
  const underlayGradient = context.createRadialGradient(
    instruction.x,
    instruction.y,
    0,
    instruction.x,
    instruction.y,
    instruction.radius,
  )
  underlayGradient.addColorStop(
    0,
    `rgba(${instruction.color.r}, ${instruction.color.g}, ${instruction.color.b}, ${instruction.centerAlpha.toFixed(3)})`,
  )
  underlayGradient.addColorStop(
    0.32,
    `rgba(${instruction.color.r}, ${instruction.color.g}, ${instruction.color.b}, ${(instruction.centerAlpha * 0.86).toFixed(3)})`,
  )
  underlayGradient.addColorStop(
    0.64,
    `rgba(${instruction.color.r}, ${instruction.color.g}, ${instruction.color.b}, ${(instruction.centerAlpha * 0.58).toFixed(3)})`,
  )
  underlayGradient.addColorStop(
    0.86,
    `rgba(${instruction.color.r}, ${instruction.color.g}, ${instruction.color.b}, ${(instruction.centerAlpha * 0.24).toFixed(3)})`,
  )
  underlayGradient.addColorStop(
    1,
    `rgba(${instruction.color.r}, ${instruction.color.g}, ${instruction.color.b}, 0)`,
  )

  context.beginPath()
  context.arc(instruction.x, instruction.y, instruction.radius, 0, Math.PI * 2)
  context.fillStyle = underlayGradient
  context.fill()
}
